import clsx from 'clsx';

import { useChangelog } from '~extension/changelog/hooks/useChangelog';
import useLabels from '~hooks/useLabels';
import { ListItem } from './ListItem';
import styles from './List.module.css';

export function List() {
  const { msgChangelogLoading, msgChangelogEmpty } = useLabels(['msgChangelogLoading', 'msgChangelogEmpty']);
  const { changelogItems, hasLoaded } = useChangelog();

  if (!hasLoaded) {
    return <div className={clsx(styles.loading, 'changelog--list--loading', 'block')}>{msgChangelogLoading}</div>;
  }

  if (!changelogItems.length) {
    return <div className={clsx(styles.empty, 'changelog-list--empty', 'block')}>{msgChangelogEmpty}</div>;
  }

  return (
    <div className={clsx(styles.list, 'changelog-list', 'flex flex-col border-solid border-b')}>
      {changelogItems.map(item => (
        <ListItem item={item} key={item.id} />
      ))}
    </div>
  );
}
